import { DODA_SITE_URL } from '@doda/common/src/constants/urls';

/**
 * 指定された検索条件クエリを基に求人検索URLを生成する関数
 *
 * @param {string[]} searchConditionQuery - 検索条件のクエリパラメータの配列
 * @returns {string} 生成された求人検索URL
 */
export const createUrl = (searchConditionQuery: string[]) => {
  const url = DODA_SITE_URL.jobSearchList.concat(
    '?',
    searchConditionQuery.join('&')
  );

  return url;
};
